var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M490.6,43H381.1V11h-20.9v32H151.7V11h-20.9v32H21.4C15.2,43,11,47.2,11,53.6v436.7c0,6.4,4.2,10.7,10.4,10.7h469.1    c6.3,0,10.4-4.3,10.4-10.7V53.6C501,47.2,496.8,43,490.6,43z M480.1,479.7H31.9V64.3h99v32h20.9v-32h208.5v32h20.9v-32h99V479.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84,170.8c-6.3,0-10.4,4.3-10.4,10.7v245c0,6.4 4.2,10.7 10.4,10.7h344c6.3,0 10.4-4.3 10.4-10.7v-245c0-6.4-4.2-10.7-10.4-10.7h-344zm333.6,245h-323.2v-223.7h323.2v223.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 214.3,
    y: 232.6,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 276.9,
    y: 232.6,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 339.4,
    y: 232.6,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 151.7,
    y: 293.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 214.3,
    y: 293.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 276.9,
    y: 293.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 339.4,
    y: 293.3,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 151.7,
    y: 355.1,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 214.3,
    y: 355.1,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 276.9,
    y: 355.1,
    height: 21.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.9,
    x: 339.4,
    y: 355.1,
    height: 21.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.77e23fdaf09b65a6f2340188037f6f97.svg";
export { ForwardRef as ReactComponent };